import { Modal } from "antd";
import { useEffect } from "react";

type ModapLGPDProps = {
  text: string;
  login: string;
  isOpen?: boolean;
  onOk?: () => void;
  onCancel?: () => void;
};

function ModalLGPD({
  text,
  login,
  isOpen = false,
  onOk,
  onCancel,
}: ModapLGPDProps) {
  useEffect(() => {
    const childElement = document.getElementById("texto-lgpd");
    if (childElement) childElement.innerHTML = text;
  }, [text]);

  return (
    <Modal
      open={isOpen}
      title="Termos de uso e Política de Privacidade"
      onOk={onOk}
      okText="Li e aceito os termos de uso e a política de privacidade"
      onCancel={onCancel}
      onClose={onCancel}
    >
      <div id="texto-lgpd"></div>
    </Modal>
  );
}

export default ModalLGPD;
